import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {
    Grid,
  } from '@material-ui/core';


const useStyles = makeStyles({
  card: {
    maxWidth:'15%',
    maxHeight:'100%',
    flex:1,
    float: 'right',
    marginLeft:'5%',
    marginRight:'0.5%'

  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function SideBar() {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <Card className={classes.card}>
      <CardContent>
      <Grid style={{marginTop:15}}>
                    <Typography variant='p' style={{fontStyle: 'italic', fontWeight: 'bold', fontSize:28}}>
                        Precautions: <br/><br/>
                    </Typography>
                    <div style={{marginLeft:'10%'}}>
                    <Typography variant='p' style={{ffontSize:20 }}>
                    💧 Wash hands frequently <br /> <br/> 💨 Maintain Social Distance  <br/> <br/>
                    </Typography>
                    <Typography variant='p' style={{ffontSize:20 }}>
                    👀👃👄 Avoid Touching Eyes, Nose, and Mouth 👀👃👄 <br/><br/>
                    </Typography>
                    <Typography variant='p' style={{ffontSize:20 }}>
                    🏥🚑If you have fever, cough, and difficulty breathing, seek medical care as soon as possible <br/><br/>
                    </Typography>
                    <Typography variant='p' style={{ffontSize:20 }}>
                    🤧 Cover coughs and sneezes  <br/><br/>Stay home if sick 😷🤒<br/><br/><br/><br/><br/><br/><br/><br/><br/>
                    </Typography>
                    </div> 
                    </Grid>
      </CardContent>
      
    </Card>
  );
}